var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContacticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315 1191 c-11 -5 -31 -21 -45 -36 -21 -22 -25 -38 -28 -100 l-4 -74 -31 -3 c-62 -6 -61 -70 2 -76 31 -3 31 -3 31 -62 0 -59 0 -59 -31 -62 -64 -6 -64 -70 0 -76 31 -3 31 -3 31 -62 0 -59 0 -59 -31 -62 -64 -6 -64 -70 0 -76 31 -3 31 -3 31 -62 0 -59 0 -59 -31 -62 -63 -6 -64 -70 -2 -76 l31 -3 4 -75 c3 -68 6 -77 36 -107 l32 -32 370 0 370 0 32 33 33 32 0 490 0 490 -33 32 -32 33 -358 2 c-196 1 -366 -2 -377 -6z m713 -83 c17 -17 17 -919 0 -936 -17 -17 -679 -17 -696 0 -7 7 -12 38 -12 69 0 57 0 58 31 61 64 6 64 70 0 76 -31 3 -31 3 -31 62 0 59 0 59 31 62 64 6 64 70 0 76 -31 3 -31 3 -31 62 0 59 0 59 31 62 64 6 64 70 0 76 -31 3 -31 3 -31 62 0 59 0 59 31 62 64 6 64 70 0 76 -31 3 -31 4 -31 61 0 31 5 62 12 69 17 17 679 17 696 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 839 c-14 -16 -19 -36 -19 -78 0 -74 36 -148 115 -234 96 -104 210 -147 260 -97 29 29 25 45 -21 95 -44 47 -68 54 -114 33 -23 -10 -29 -8 -66 28 -49 48 -56 74 -34 120 20 42 12 71 -36 122 -35 37 -58 40 -85 11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacticon);
export default __webpack_public_path__ + "static/media/contacticon.939f4618741830dfa94d37118bfdfe12.svg";
export { ForwardRef as ReactComponent };